const { trackGtm4, disableStaticURL } = require('util/functions');

module.exports = {
	init() {
		const linkTitle = this.root.querySelector('.news-and-press-item--title');
		const topLink = this.root.querySelector('.news-and-press-item--top-link');
		const widgetName = this.root.getAttribute('data-parent');
		const widgetTitle = this.root.getAttribute('data-parent-title');

		linkTitle.addEventListener('click', () => {
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: widgetName,
				widget_title: widgetTitle ? widgetTitle : 'No title: Title not set',
				link_text: linkTitle.innerHTML,
				link_url: linkTitle.href,
				button_type: '',
			});
		});

		topLink.addEventListener('click', () => {
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: widgetName,
				widget_title: widgetTitle ? widgetTitle : 'No title: Title not set',
				link_text: topLink.innerHTML ? topLink.innerHTML : 'No text: Icon link',
				link_url: topLink.href,
				button_type: '',
			});
			if (topLink.hasAttribute('download')) {
				disableStaticURL(topLink, 'download-disabled');
			}
		});
	},
};
